export default "__VITE_ASSET__066d08fc__"